var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.taxon.name)?[_vm._v("\n    Quickly grab all the "+_vm._s(_vm.taxon.name)+" you need and add them\n  ")]:[_vm._v("\n    Select a product category below and quickly add what you need\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }